import { object, ref, string } from "yup";

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&#]{8,}$/;

export const passwordCriteria = (passwordObj: any | undefined): string => {
  const password = passwordObj.value;
  if (!password) return "Password must meet all criteria";
  const criteria = [
    ["at least 8 characters", password.length >= 8],
    ["one lowercase letter", /[a-z]/.test(password)],
    ["one uppercase letter", /[A-Z]/.test(password)],
    ["one digit", /\d/.test(password)],
    ["one symbol", /[@$!%*?&#]/.test(password)],
  ];
  const missingCriteria = criteria
    .filter(([_, isValid]) => !isValid)
    .map(([msg]) => msg);
  return missingCriteria.length
    ? `Password must contain ${missingCriteria.join(", ")}`
    : "";
};

const newPasswordObj = {
  new_password: string()
    .required("New password is required")
    .matches(passwordRegex, passwordCriteria),
  confirm_password: string()
    .oneOf([ref("new_password"), null], "Passwords do not match")
    .required("Confirm password is required"),
};

export const forgotPasswordSchema = object({
  ...newPasswordObj,
  old_password: string().required("Old password is required"),
});

const createPasswordSchema = object({ ...newPasswordObj });

export const resetPassword = object({
  email: string().email().required(),
});

export default createPasswordSchema;
